import type { FunctionComponent, PropsWithChildren } from "react";

const FormInputError: FunctionComponent<PropsWithChildren> = ({ children }) => {
	return <p className="mt-2 whitespace-pre-wrap text-sm text-red-600">
		{children}
	</p>;
};

export default FormInputError;